export default "__VITE_ASSET__CbErpGy6__"